var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_shopping_bag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_152_630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_152_630)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shopping_bag",
    d: "M6.3077 21.5C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V8.30772C4.5 7.80259 4.675 7.37502 5.025 7.02502C5.375 6.67502 5.80257 6.50002 6.3077 6.50002H8.25V6.25002C8.25 5.21412 8.61603 4.33015 9.34808 3.5981C10.0801 2.86605 10.9641 2.50002 12 2.50002C13.0359 2.50002 13.9198 2.86605 14.6519 3.5981C15.3839 4.33015 15.75 5.21412 15.75 6.25002V6.50002H17.6922C18.1974 6.50002 18.625 6.67502 18.975 7.02502C19.325 7.37502 19.5 7.80259 19.5 8.30772V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5H6.3077ZM6.3077 20H17.6922C17.7692 20 17.8397 19.968 17.9038 19.9039C17.9679 19.8397 18 19.7692 18 19.6923V8.30772C18 8.23079 17.9679 8.16027 17.9038 8.09615C17.8397 8.03205 17.7692 8 17.6922 8H15.75V10.25C15.75 10.4628 15.6782 10.641 15.5346 10.7846C15.391 10.9282 15.2128 11 15 11C14.7872 11 14.609 10.9282 14.4654 10.7846C14.3218 10.641 14.25 10.4628 14.25 10.25V8H9.74995V10.25C9.74995 10.4628 9.67816 10.641 9.53457 10.7846C9.39099 10.9282 9.21279 11 8.99997 11C8.78716 11 8.60896 10.9282 8.46537 10.7846C8.32179 10.641 8.25 10.4628 8.25 10.25V8H6.3077C6.23077 8 6.16024 8.03205 6.09612 8.09615C6.03202 8.16027 5.99997 8.23079 5.99997 8.30772V19.6923C5.99997 19.7692 6.03202 19.8397 6.09612 19.9039C6.16024 19.968 6.23077 20 6.3077 20ZM9.74995 6.50002H14.25V6.25002C14.25 5.62309 14.0317 5.09136 13.5952 4.65482C13.1586 4.21827 12.6269 4 12 4C11.373 4 10.8413 4.21827 10.4048 4.65482C9.96822 5.09136 9.74995 5.62309 9.74995 6.25002V6.50002Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping_bag.1dab2b8dd81449baa76c235533307d79.svg";
export { ForwardRef as ReactComponent };